<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>FullCalendar Pro</h1>
					<p waBody="m" waText>Premium calendar features &mdash; resource timeline, resource day/time grids, adaptive mobile views, and enterprise scheduling extending the community FullCalendar plugin. Schedule events across multiple resources &#40;rooms, people, equipment&#41; with horizontal timeline views.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">FullCalendar Pro 6.1.19</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="warning">License Required</wa-tag>
					</div>
					<p waBody="s" waColorText="warning" waText>FullCalendar Pro requires an active premium subscription. Get your license at fullcalendar.io/pricing</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:fullcalendar-pro</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.fullcalendarpro</p>
					<p waBody="s" waText>Built on: FullCalendar Pro 6.1.19</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_109" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_110" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>NPM DEPENDENCIES &#40;auto-included&#41;</div>
					<markdown [data]="mdContent_111" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Resource scheduling &mdash; schedule events across rooms, people, and equipment</p>
					<p waBody="s" waColorText="quiet" waText>Timeline views &mdash; horizontal timeline for resource scheduling and planning</p>
					<p waBody="s" waColorText="quiet" waText>Resource DayGrid &mdash; day/week/month grid views with resource grouping</p>
					<p waBody="s" waColorText="quiet" waText>Resource TimeGrid &mdash; time-based grid views with resource columns</p>
					<p waBody="s" waColorText="quiet" waText>Adaptive mobile views &mdash; responsive calendar views optimized for mobile</p>
					<p waBody="s" waColorText="quiet" waText>Vertical resource view &mdash; display resources as vertical columns</p>
					<p waBody="s" waColorText="quiet" waText>Extends community FullCalendar &mdash; all standard features included</p>
					<p waBody="s" waColorText="quiet" waText>Type-safe Java API &mdash; CRTP fluent API for resource configuration</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Resource Timeline</h4>
						<p waBody="s" waColorText="quiet" waText>Create a resource timeline with multiple rooms and events.</p>
						<markdown [data]="mdContent_112" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_113" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>FullCalendarProPageConfigurator registers resource timeline, resource grid, and adaptive plugins</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
						<wa-tag pill variant="neutral">FullCalendar Pro License</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://fullcalendar.io/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://fullcalendar.io/docs/premium</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/FullCalendarPro</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>